import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import api from '../../utils/api';
import '../../components/public/Public.css';
import './EventDetail.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function EventDetail() {
  const { slug }  = useParams();
  const navigate  = useNavigate();
  const [event, setEvent]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/public/events/${slug}`)
      .then(r => { if (active) setEvent(r.data); })
      .catch(() => { if (active) setNotFound(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [slug]);

  const fmtFull = (d) => d ? new Date(d).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : '';
  const fmtTime = (t) => {
    if (!t) return '';
    const [h, m] = t.split(':'); const hh = parseInt(h);
    return `${hh % 12 || 12}:${m} ${hh >= 12 ? 'PM' : 'AM'}`;
  };
  const dateRange = (s) => {
    if (!s.start_date) return '';
    const sd = new Date(s.start_date);
    const ed = s.end_date ? new Date(s.end_date) : null;
    if (ed && ed.toDateString() !== sd.toDateString()) return `${fmtFull(s.start_date)} → ${fmtFull(s.end_date)}`;
    return fmtFull(s.start_date);
  };

  if (loading) return <div className="pub-page"><Navbar /><div className="pub-loading"><div className="pub-spinner" /></div><Footer /></div>;

  if (notFound || !event) return (
    <div className="pub-page">
      <Navbar />
      <div className="pub-empty" style={{ flex: 1 }}>
        <div className="pub-empty-ic">🔍</div>
        <h3>Event not found</h3>
        <p>This event doesn't exist or is no longer available.</p>
        <Link to="/" className="pub-btn pub-btn-primary" style={{ marginTop: 20 }}>← Back to Events</Link>
      </div>
      <Footer />
    </div>
  );

  const sessions = event.sessions || [];
  const first = sessions[0];

  return (
    <div className="pub-page">
      <Navbar />

      <div className="ed-hero">
        {event.image_url ? <img src={'https://testapi.aiworldcommunity.com' + event.image_url} alt={event.title} className="ed-hero-img" /> : <div className="ed-hero-ph" />}
        <div className="ed-hero-veil">
          <div className="pub-container">
            <Link to="/" className="ed-back">← All events</Link>
            <div className="ed-chips">
              <span className={`ed-chip ${event.is_free ? 'free' : 'paid'}`}>{event.is_free ? 'FREE' : `${event.currency} ${parseFloat(event.price).toFixed(2)}`}</span>
              <span className="ed-chip glass">{event.venue_type === 'Online' ? '💻 Online' : event.venue_type === 'Physical' ? '📍 In-person' : '🌐 Hybrid'}</span>
              {first && <span className="ed-chip glass">📅 {first.start_date ? new Date(first.start_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'TBA'}</span>}
            </div>
            <h1>{event.title}</h1>
          </div>
        </div>
      </div>

      <div className="pub-container ed-body">
        <div className="ed-main">
          {event.description && (
            <section className="ed-sec">
              <h2>About this event</h2>
              <p className="ed-text">{event.description}</p>
            </section>
          )}

          {(event.details || []).map((d, i) => (
            <section className="ed-sec" key={i}>
              <h2>{d.heading}</h2>
              <p className="ed-text">{d.description}</p>
            </section>
          ))}

          {sessions.length > 0 && (
            <section className="ed-sec">
              <h2>Schedule</h2>
              <div className="ed-sessions">
                {sessions.map((s, i) => (
                  <div className="ed-session" key={i}>
                    <div className="ed-session-icon">{MONTHS[new Date(s.start_date).getMonth()]}<b>{new Date(s.start_date).getDate()}</b></div>
                    <div className="ed-session-info">
                      {s.session_label && <span className="ed-session-label">{s.session_label}</span>}
                      <div className="ed-session-range">{dateRange(s)}</div>
                      {(s.start_time || s.end_time) && (
                        <div className="ed-session-time">🕐 {fmtTime(s.start_time?.slice(0,5))}{s.end_time ? ` – ${fmtTime(s.end_time?.slice(0,5))}` : ''}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>

        <aside className="ed-aside">
          <div className="ed-reg-card">
            <div className="ed-reg-price">
              {event.is_free ? <span className="free">Free</span> : <><span className="cur">{event.currency}</span><span className="amt">{parseFloat(event.price).toFixed(2)}</span></>}
            </div>
            <div className="ed-reg-meta">
              <div className="ed-reg-row"><span>📅 Sessions</span><b>{sessions.length}</b></div>
              <div className="ed-reg-row"><span>🎟️ Format</span><b>{event.venue_type}</b></div>
              {event.venue_details && <div className="ed-reg-row col"><span>{event.venue_type === 'Online' ? '🔗 Where' : '🏛️ Venue'}</span><b className="venue">{event.venue_details}</b></div>}
            </div>
            <button className="pub-btn pub-btn-primary ed-reg-btn" onClick={() => navigate(`/register/${slug}`)}>Register now →</button>
            <p className="ed-reg-note">Quick & secure — takes about a minute.</p>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
}
